import React from 'react'
import Menu from '../component/Menu';
import { Helmet } from 'react-helmet';
import Getintouch2 from '../component/Getintouch2'
import FooterNew from '../component/FooterNew';
import ServicesHeader from '../component/ServicesHeader';
import Whoweserve from '../component/Whoweserve';
import ServiceDesc from '../component/ServiceDesc';
import AIInServices from '../component/AIInService';
import ServiceSection from '../component/ServiceSection';

import heroimage from '../images/Management-consulting-bg.webp';

import service1heroImage from '../images/StrategyConsulting.webp';
import ser1cs from '../images/case-study-client7.webp';
import service2heroImage from '../images/BusinessOperationsConsulting.webp';
import ser2cs from '../images/case-study-client3.webp';
import service3heroImage from '../images/ProjectManagement.webp';
import ser3cs from '../images/case-study-client16.webp';
import FaqServices from '../component/FaqServices';
import ServiceCS from '../component/ServiceCS';

import mccs1 from '../images/case-study-client46.webp';
import mccs2 from '../images/case-study-client45.webp';
import mccs3 from '../images/case-study-client37.webp';


const herocontent = {
  "l1": "Insight driven",
  "l2": "Management Consulting",
  "l3": "Building sustainable advantage through bespoke solutions",
  "img": heroimage
};


const serviceDes = {
    description:
      "Our seasoned consultants leverage deep industry expertise, data-driven methodologies, and AI-enabled research and analysis to help CXOs drive value creation across their organisations through strategic transformation, operational excellence, and sustainable growth",

    stats: [
      {
        title: "35+",
        text: "Sectors Served",
      },
      {
        title: "150+",
        text: "Clients Advised",
      },
      {
        title: "90+",
        text: "Strategy Engagements Delivered",
      },
    ],

    cta: {
      text: "VIEW OUR CASE STUDIES",
      href: "/case-studies",
    },
  };

const aiManagementConsultingData = {
    eyebrow: "ARTIFICIAL INTELLIGENCE",

    title: "AI in Management Consulting",

    description:
      "AI is redefining how strategy gets built - and how fast. For the corporates and business leaders we serve, AI is no longer a differentiator to explore someday; it is fast becoming table stakes for competitive decision-making. We help you embed AI across your strategy function so every plan you build is sharper, faster, and grounded in deeper evidence - without adding headcount.",

    cards: [
      {
        icon: "fpa",
        title: "Sharper strategic insight",
        description:
          "We combine AI-powered market intelligence with our structured research frameworks to scan markets, competitors, and customer signals at a scale and speed manual research cannot match - giving your leadership team earlier visibility into risks and opportunities.",
      },
      {
        icon: "reporting",
        title: "Faster planning cycles",
        description:
          "From business plans and feasibility studies to GTM strategies, we use AI to compress research, modeling, and drafting timelines - so strategy documents that once took weeks are stress-tested and board-ready in days.",
      },
      {
        icon: "risk",
        title: "Smarter execution & monitoring",
        description:
          "We help you build AI-enabled performance dashboards and early-warning systems that track strategy execution in real time, flag deviations, and keep initiatives accountable to the outcomes they promised.",
      },
    ],

    bottom: [
      {
        title: "REAL OUTCOMES",
        description:
          "We've helped clients apply an AI lens to their strategic agenda - from accelerating market entry research for a new venture to building AI-assisted competitive intelligence that reshaped a client's expansion roadmap. The result: faster decisions, backed by deeper evidence.",
          linkText: "Read the case study",
        href: "/case-studies",
      },
      {
        title: "HOW WE HELP",
        description:
          "Our consultants work as an extension of your team, pairing proven strategy frameworks with generative and agentic AI tools across research, planning, and performance management - so you get consulting-grade output at offshore speed and cost.",
        linkText: "Talk to our team",
        href: "/contact",
      },
    ],
  };

  const ManagementConsultingicons = {
  fpa: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.6663 21.9812C20.5583 21.0665 22.6237 19.8065 23.0023 16.6532C23.1536 15.6876 23.1031 14.7011 22.8541 13.756C22.6052 12.8109 22.1631 11.9276 21.5559 11.1618C20.9486 10.396 20.1893 9.76432 19.3257 9.30656C18.4622 8.84879 17.5132 8.57488 16.5386 8.50208C15.564 8.42928 14.5848 8.55918 13.6629 8.88358C12.7409 9.20799 11.8962 9.71987 11.1819 10.387C10.4676 11.054 9.89923 11.8619 9.51263 12.7595C9.12604 13.6572 8.9296 14.6252 8.93568 15.6025C8.93568 19.5372 11.3197 20.9678 12.333 21.9812C13.1277 22.7998 13.005 23.1065 13.005 24.4265C12.9958 24.5929 13.0205 24.7594 13.0778 24.9159C13.135 25.0724 13.2236 25.2156 13.338 25.3367C13.4524 25.4579 13.5903 25.5544 13.7432 25.6205C13.8962 25.6866 14.061 25.7209 14.2277 25.7212H17.7717C17.9384 25.7215 18.1035 25.6876 18.2566 25.6217C18.4098 25.5558 18.5479 25.4592 18.6623 25.3379C18.7767 25.2166 18.8651 25.0732 18.922 24.9164C18.9789 24.7597 19.003 24.5929 18.993 24.4265C18.933 23.0812 18.773 22.8985 19.6663 21.9812Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.946 25.6476V27.6636C13.946 28.2143 14.2526 28.6663 14.63 28.6663H17.3673C17.7473 28.6663 18.0526 28.2129 18.0526 27.6636V25.6476M14.9593 11.5943C14.172 11.5946 13.4171 11.9076 12.8605 12.4644C12.304 13.0213 11.9913 13.7763 11.9913 14.5636M25.7753 15.8716H28.2206M23.314 7.85561L25.0486 6.12095M24.6473 22.6663L26.382 24.3996M15.9993 3.16895V5.14628M6.98596 6.11961L8.70863 7.85561M5.65263 24.3996L7.3753 22.6663M6.2233 15.8716H3.7793" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
  ),

  reporting: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.33268 5.86702C9.74487 3.79644 12.8204 2.66087 15.9993 2.66702C23.3527 2.66702 29.3327 8.65368 29.3327 16.007C29.3327 23.3604 23.3527 29.3404 15.9993 29.3404C8.64602 29.3404 2.66602 23.3604 2.66602 16.007C2.66602 14.5204 2.90602 13.067 3.38602 11.6737L5.27935 12.3204C4.87302 13.5047 4.66577 14.7482 4.66602 16.0004C4.66602 22.247 9.75268 27.3337 15.9993 27.3337C22.246 27.3337 27.3327 22.247 27.3327 16.0004C27.3327 9.75368 22.246 4.66702 15.9993 4.66702C13.2927 4.66702 10.7393 5.62702 8.71268 7.33368H11.9993V9.33368H6.99935C6.07935 9.33368 5.33268 8.58702 5.33268 7.66702V2.66702H7.33268V5.86702ZM14.9993 16.4137V8.66035H16.9993V15.587L21.0393 19.627L19.626 21.0404L14.9993 16.4137Z" fill="white"/></svg>
  ),

  risk: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0007 6.66699C8.74199 6.66699 4.70866 12.3123 3.27532 14.8217C2.98066 15.3363 2.83399 15.595 2.84866 15.979C2.86599 16.363 3.03932 16.6137 3.38466 17.115C5.09132 19.5923 9.72599 25.3337 16.0007 25.3337C22.2753 25.3337 26.91 19.5923 28.6167 17.115C28.9633 16.6137 29.1367 16.363 29.1513 15.979C29.166 15.595 29.0207 15.3363 28.726 14.8217C27.294 12.3123 23.2593 6.66699 16.0007 6.66699Z" stroke="white" stroke-width="1.5"/><path d="M16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z" stroke="white" stroke-width="1.5"/></svg>

  ),
};

const StrategicConsulting = {
  title: ["Strategy Consulting"],

  accentColor: "#f21b70",
  bg:'#ffffff',
  subtitle:
    "Combining deep industry expertise, data-driven insights, and AI-enhanced analysis, we help organisations identify opportunities, navigate complexity, and build strategies for sustainable growth.",

  relevantFor: [
    "Corporates",
    "Private Equity / Venture Capital",
    "Family Offices",
    "Real Estate",
  ],

  heroImage:
    service1heroImage,

  services1: [
    {
      title: "Strategy development",
      description:
        "Identify new opportunities, optimize existing portfolio and align business units for maximum operational effectiveness.",
    },
    {
      title: "Business plans",
      description:
        "Align resources towards a unified vision of creating exceptional value for all your stakeholders and gaining competitive advantage.",
    },
    {
      title: "Investment strategy",
      description:
        "Optimize investment decisions, identify lucrative opportunities and mitigate risk through a robust investment strategy aligned with your financial goals.",
    },
    
    {
      title: "Strategy Implementation",
      description:
        "Achieve your organizational goals by translating your strategic plans into actionable initiatives through a well crafted implementation strategy.",
    },
  ],

  services2: [
    
  ],

  caseStudy: {
    label: "CASE STUDY",
    image:ser1cs,
    title:"Corporate Strategy",
    description:"The deployment of organization-wide dashboards across HR, finance, project management, infrastructure, and other functions equipped the client with an enhanced medium for extracting actionable insights from their data. The overall solution improved data accuracy and accessibility, enabling function leaders to make informed decisions based on reliable insights.",
    buttonLabel: "→",
    href: "/knowledge/corporate-strategy-for-a-real-estate-development-company",
  },
};

const BusinessConsulting = {
  title: ["Business Operations Consulting"],

  accentColor: "#f21b70",
  bg:'#EBEBEB',
  subtitle:
    "Leveraging process expertise, operational best practices, and AI-enabled workflow intelligence, we help organisations improve efficiency, strengthen execution, and drive operational excellence.",

  relevantFor: [
    "Corporates & Growth-Stage Businesses",
    "Asset Managers",
    "Family Offices",
  ],

  heroImage:
    service2heroImage,

  services1: [
    {
      title: "Performance management",
      description:
        "Drive high-performance outcomes by implementing effective performance measurement systems, monitoring framework and fostering a culture of productivity.",
    },
    {
      title: "Finance Support",
      description:
        "Achieve growth goals by aligning financial budgets with corporate objectives. Develop investment strategies, optimize capital allocation, and achieve your organization's financial objectives through comprehensive solutions that maximize returns and mitigate risks.",
    },
    {
      title: "Organization design",
      description:
        "Adapt to evolving market dynamics and drive sustainable growth by creating structures that foster agility, collaboration, and efficiency. Annual Operating Plans.",
    },    
    {
      title: "Annual Operating Plans",
      description:
        "Achieve optimum performance and effective execution through tailored operating plans that offer a framework to set goals, allocate resources, and define key initiatives.",
    },
    
    
  ],

  services2: [
   {
      title: "Process Consulting",
      description:
        "Streamline workflows through creative frameworks and flowcharts prepared on basis of industry best practices.",
    },
  ],

  caseStudy: {
    label: "CASE STUDY",
    image:ser2cs,
    title:"Streamlining Business Processes",
    description:"The Procedure Manual and Process Flow Diagram enabled the client to control and streamline its business process and implement the ERP system effectively and seamlessly.",
    buttonLabel: "→",
    href: "/knowledge/streamlining-business-and-facilitating-the-implementation-of-an-erp-system",
  },
};

const ProjectManagement = {
  title: ["Project Management"],

  accentColor: "#f21b70",
  bg:'#ffffff',
  subtitle:
    "Through robust governance frameworks, performance monitoring, and AI-assisted reporting, we help organisations translate strategy into successful execution and measurable outcomes.",

  relevantFor: [
    "Investment Banks & Advisors",
    "Sovereign Wealth & Endowment Funds",
    "Corporates",
    "Private Equity / Venture Capital",
  ],

  heroImage:
    service3heroImage,

  services1: [
    {
      title: "Enterprise Project Management Office (EPMO)",
      description:
        "Allocate resources efficiently, mitigate risks and enhance project outcomes through a centralized framework designed to execute and control projects across the enterprise.",
    },
    
    {
      title: "Project Management Office (PMO)",
      description:
        "A centralized hub focused on standardizing project management practices, ensuring organizational alignment and providing oversight and support for efficient project delivery.",
    },

    {
      title: "Strategic Management Office (SMO)",
      description:
        "Bridge the gap between planning and implementation through frameworks designed to enable effective execution and drive continuous improvement.",
    },
    
    
  ],

  services2: [
    {
      title: "Transformation Management Office (TMO)",
      description:
        "Drive complex transformation initiatives with structured governance, change management, stakeholder alignment, and benefits realisation frameworks designed to accelerate adoption and deliver sustainable business outcomes.",
    },
  ],

  caseStudy: {
    label: "CASE STUDY",
    image:ser3cs,
    title:"Enterprise Project Management Office",
    description:"The client is a subsidiary of a sovereign wealth fund that functions as a real estate development company. With a mandate totaling approximately $20 billion, the company operates across diverse segments within the real estate sector.",
    buttonLabel: "→",
    href: "/knowledge/enterprise-project-management-office-for-a-real-estate-development-company",
  },
};


 const faqData = {
    title: "What Leaders Want To Know",

    defaultOpen: 0,

    items: [
      {
        question:
          "What business problems does Preferred Square typically solve for management consulting clients?",

        answer:
          "Clients typically reach out when strategy exists on paper but isn't converting into execution decisions made without a structured framework, functions operating in silos, and management reporting that's limited or absent. Common triggers include an unclear authority matrix, a formally adopted plan that was never implemented, or growth that has plateaued without a diagnosed cause. Most organisations try solving this internally first, spreading existing analysts across multiple mandates capacity runs out and quality drops, since analytical depth can't be produced part-time alongside an operating role.",
      },

      {
        question:
          "What does a management consulting engagement produce, and what do clients keep afterward?",

        answer:
          "The five most common deliverables are feasibility and highest-and-best-use studies, business plans, corporate strategy, market and industry studies, and board and management reporting decks - each built for a named stakeholder and decision. Clients typically keep more than the deliverable itself: a standardised model and deck architecture their team keeps using, the underlying financial models as a reference version for planning cycles, a recurring reporting pack, and a defined process for how analysis moves from data to decision.",
      },
      {
        question:
          "Which clients, sectors, and geographies does Preferred Square work with?",

        answer:
          "Clients span real estate developers and owners, private equity and venture capital funds, family offices, asset managers, and corporates, each with a different consulting mix. Real estate and development mandates concentrate in Saudi Arabia and the wider Gulf; corporate strategy and business planning work concentrates in the US and Europe alongside the Gulf. Real estate and private equity are where repeat history runs deepest. Delivery runs from Preferred Square's centre in India, with team overlap windows structured to give clients live access for a substantial part of their working day.",
      },
      {
        question:
          "Why choose Preferred Square over a large consulting firm, a freelancer, or an in-house hire?",

        answer:
          "Clients choose Preferred Square for senior attention and a structured delivery model at materially lower cost than an onshore firm without a freelancer's continuity risk or a permanent hire's fixed commitment. Against large firms: lower cost, senior attention on every mandate, and less overhead between question and answer. Against freelancers: ISO- and SOC 2-certified security, team depth instead of one person, and continuity through personnel change. Against in-house hiring: faster to mobilise, scalable with workload, and no recruitment or retention exposure.",
      },
      {
        question:
          "Who will be working on a Preferred Square engagement?",

        answer:
          "Every engagement is staffed by a multi-tier team analyst, consultant, and a Senior Consultant acting as Engagement Lead rather than a single resource. Analysts handle modelling, research, and data work directly with the client; consultants own analytical structure and review output; the Senior Consultant is accountable for the mandate. Teams are assigned by role, not named individual, so capacity scales with the mandate several engagements have grown from one resource to five without disrupting who's leading the work, and no single person is a point of failure.",
      },
      {
        question:
          "How is the impact of an engagement measured?",

        answer:
          "Impact is measured against the decision the work was commissioned to support, agreed at the outset rather than assessed afterward whether a feasibility study led to a go/no-go, or a business plan supported funding approval. For ongoing work, the measures are capacity released back to the client team and how much they can run unaided using the models left behind. The most consistent long-term signal is scope expansion. Preferred Square runs a structured feedback programme, and 96% of clients say they'd refer the firm.",
      },
      {
        question:
          "How are engagements structured, and how quickly do they start?",

        answer:
          "Engagements run in four structures: fixed-scope (a defined deliverable like a feasibility study), dedicated team (sustained capacity that scales with the mandate), retained advisory (recurring reporting or monitoring), and block-of-hours (flexible, drawn down as needed, without a dedicated team). Week one is a kickoff call and structured workshops to scope the work; the first tangible output typically reaches clients within two to five days, followed by weekly calls and iterative review rather than a long silence before a single document.",
      },
      {
        question:
          "Is Preferred Square ISO and SOC 2 compliant?",

        answer:
          "Yes controls cover data confidentiality, integrity, and access management across every engagement. These questions come most often from institutional investors and global corporates, concerned with deal-data confidentiality, regulatory compliance, and operational risk in an offshore model. NDAs and data processing agreements are executed before any data is shared, and engagements run in either the client's own environment or Preferred Square's secured one, per the client's governance requirements. Certification means these questions are answered with audit evidence, not assurance.",
      },
      {
        question:
          "Do management consulting engagements expand beyond the original scope?",

        answer:
          "Frequently most relationships begin with a single deliverable that builds confidence, then widen. A Gulf developer engaged Preferred Square for a strategic business plan delivered in three months against a compressed deadline; that led to a portfolio-level financial model covering roughly 400 assets across residential, retail, hospitality, and logistics, growing the team from one resource to five. The mandate later extended into annual operating plans, budgeting support, and commercial asset management driven by consistent delivery, deep understanding of the client's assets, and proactive engagement with senior stakeholders.",
      },
    ],
  };

  const  caseStudies =  {
  "sectionTitle": "Case Studies",
  "items": [
    {
      "id": 1,
      "image": mccs1,
      "title": "Business Requirements Document (BRD) Development",
      "description": "A strategic holding company operating across the technology, real estate, and prop-tech sectors, with a focus on building and scaling high-value ventures",
      "link": "/knowledge/business-requirements-document-(brd)-development"
    },
    {
      "id": 2,
      "image": mccs2,
      "title": "Enterprise Risk Management Comprehensive ERM Framework",
      "description": "A family office managing a real estate portfolio, aiming to enhance governance and establish a proactive framework for enterprise-wide risk identification and mitigation",
      "link": "/knowledge/enterprise-risk-management-comprehensive-erm-framework-for-a-family-office"
    },
    {
      "id": 3,
      "image": mccs3,
      "title": "Brand Landscaping for a Destination Development Client",
      "description": "The client operates in destination development, specializing in creating culturally immersive and architecturally iconic landmarks. By integrating Eastern heritage, it delivers transformative real estate experiences",
      "link": "/knowledge/brand-landscaping-for-a-destination-development-client"
    }
  ]
}

const ManagementConsultingService = ({setBlank}) => {
  return (
     <>
        <Helmet>
            <title>Management Consulting</title>
             <meta property="og:title" content="Management Consulting" />
             <meta name='og:description' content='Management Consulting' />
             <meta name='keywords' content='' />
        </Helmet>
        <Menu setBlank={setBlank} />
        <ServicesHeader herocontent={herocontent} />
        <ServiceDesc serviceDes={serviceDes} />
        <AIInServices data={aiManagementConsultingData} icons={ManagementConsultingicons} />
        <ServiceSection data={StrategicConsulting} />
        <ServiceSection data={BusinessConsulting} />
        <ServiceSection data={ProjectManagement} />
        <Whoweserve />
        <Getintouch2 setBlank={setBlank} />
        <ServiceCS caseStudies={caseStudies} />
        <FaqServices data={faqData} />
        <FooterNew setBlank={setBlank} />
     </>
  )
}

export default ManagementConsultingService



